// Importing SASS files
import './../style/main.scss';

// Importing NPM Packages
import locomotiveScroll from 'locomotive-scroll';

// DOM Strings
const domEl = {
    cursor: document.querySelector('.cursor'),
    about: document.querySelector('.about'),
    heading: document.querySelector('.heading'),
    project: document.querySelector('.project'),
    menu: document.querySelector('.nav__btn'),
    projectAll: document.querySelectorAll('.project__link')
}

//////////////////////////////////////////////////////////////////
// MENU
const close =  function(){
    let text = this.textContent;
    const nav = document.querySelector('.nav__link');

    if(text === 'MENU') {
        this.textContent = 'CLOSE';
        nav.style.width = '100%';
    } else if (text === 'CLOSE') {
        this.textContent = 'MENU'
        nav.style.width = null;
    }
}
//handler for the naviagation button
document.querySelector('.nav__btn').addEventListener('click',close);

const data = document.querySelectorAll('.nav__close');

//Handler for navigation links
data.forEach(el => el.addEventListener('click', function() {
    const nav = document.querySelector('.nav__btn');
    const con = document.querySelector('.nav__link');

    if(nav.textContent === 'CLOSE') {
        con.style.width = null;
        nav.textContent = 'MENU';  
    }  
    //close.call(nav);
}));

//////////////////////////////////////////////////////////////////
// Locomotive Scroll
const scroll = new locomotiveScroll({
    el: document.querySelector('.container'),
    smooth: true,
    multiplier: .6
});
////////////////////////////////////////////////////////////////
// Cursor
const mediaQuery = window.matchMedia('(min-width: 900px)')
function handleTabletChange(e) {
  // Check if the media query is true
  if (e.matches) {
    // Then log the following message to the console
    console.log('Media Query Matched!');

    let cursor = document.querySelector('.cursor');
    window.addEventListener('mousemove', function(e) {
        cursor.style.top = e.pageY + 'px';
        cursor.style.left = e.pageX + 'px';
    });

    // Heading Cursor
    domEl.heading.addEventListener("mouseover", (e) => {
        domEl.cursor.classList.add('headingC');
    });
    domEl.heading.addEventListener("mouseleave", (e) => {
        domEl.cursor.classList.remove('headingC');
    });

    // Menu Cursor
    domEl.menu.addEventListener("mouseover", (e) => {
        domEl.cursor.classList.add('menuC');
    });
    domEl.menu.addEventListener("mouseleave", (e) => {
        domEl.cursor.classList.remove('menuC');
    });

    // About Image Cursor
    domEl.about.addEventListener("mouseover", (e) => {
        domEl.cursor.classList.add('aboutC');
    });
    domEl.about.addEventListener("mouseleave", (e) => {
        domEl.cursor.classList.remove('aboutC');
    });

    // Project Cursor
    domEl.projectAll.forEach(el => {
        el.addEventListener('mouseover', function() {
            cursor.classList.add('projectC');
            cursor.innerHTML = 'View <br> Project';
        });

        el.addEventListener('mouseleave', function() {
            cursor.classList.remove('projectC');
            cursor.textContent = '';
        });
    })

  }
}
// Register event listener
mediaQuery.addListener(handleTabletChange)
// Initial check
handleTabletChange(mediaQuery)